import * as server from '../entries/pages/czynnosci-notarialne/_page.server.ts.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/czynnosci-notarialne/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/czynnosci-notarialne/+page.server.ts";
export const imports = ["_app/immutable/nodes/7.CZ8rePl2.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/CpR9_xLq.js","_app/immutable/chunks/CW2ixiyS.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/nKiQWsiX.js"];
export const stylesheets = ["_app/immutable/assets/PageHeadingSection.lmfBmTxA.css"];
export const fonts = [];
